import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, CheckCircle, Camera, Sparkles } from "lucide-react";

const seekUrl = (u) => u ? (typeof u === 'string' && u.includes('#') ? u : u + '#t=0.5') : u;


const ServicePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Service data
  const servicesData = {
    "imagefilm": {
      title: "Imagefilm",
      tagline: "Ihre Marke. Ihre Geschichte. Professionell inszeniert.",
      description: "Ein Imagefilm ist mehr als nur ein Video – er ist das Herzstück Ihrer Unternehmenskommunikation. Authentisch, emotional und auf den Punkt gebracht zeige ich, wer Sie sind, wofür Sie stehen und was Sie einzigartig macht.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/geiger-kunedzufriedenheit-fuer-die-em-2024.mp4",
      additionalVideos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-der-snack-der-dich-findet.mp4"
      ],
      btsVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/bts.mp4",
          format: "16:9"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/img-1575.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/werbevideo-bts-1.mp4",
          format: "9:16"
        }
      ],
      hero: {
        title: "Imagefilme, die im Gedächtnis bleiben",
        subtitle: "Von der ersten Idee bis zum finalen Cut – ich begleite Sie durch den gesamten Produktionsprozess und schaffe visuelle Geschichten, die Ihre Zielgruppe begeistern."
      },
      benefits: [
        "Professionelle Markeninszenierung mit emotionaler Tiefe",
        "Authentische Darstellung Ihrer Unternehmenswerte",
        "Von der Konzeption bis zur finalen Postproduktion",
        "Optimiert für Website, Social Media und Präsentationen",
        "Cinema-Look mit modernster Kameratechnik"
      ],
      process: [
        {
          title: "Konzeption & Planung",
          description: "Gemeinsam entwickeln wir das Storytelling und definieren die visuelle Sprache Ihres Imagefilms."
        },
        {
          title: "Produktion",
          description: "Mit professionellem Equipment und kreativer Regie setze ich Ihre Marke perfekt in Szene."
        },
        {
          title: "Postproduktion",
          description: "Color Grading, Sound Design und Motion Graphics – für einen Film, der begeistert."
        }
      ],
      useCases: [
        "Unternehmensvorstellung auf der Website",
        "Recruiting & Employer Branding",
        "Messeauftritte & Events",
        "Social Media Kampagnen",
        "Investoren-Präsentationen"
      ],
      cta: {
        title: "Bereit für Ihren Imagefilm?",
        subtitle: "Lassen Sie uns gemeinsam Ihre Geschichte erzählen."
      }
    },
    "recruiting": {
      title: "Recruiting Videos",
      tagline: "Talente gewinnen. Authentisch. Emotional.",
      description: "In Zeiten des Fachkräftemangels ist ein starkes Employer Branding entscheidend. Recruiting-Videos zeigen authentisch, was Ihr Unternehmen als Arbeitgeber auszeichnet – und sprechen genau die Talente an, die Sie suchen.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/weisser-und-griesshaber-gmbh-recruiting-video-2022.mp4",
      additionalVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/servicemitarbeiter-mwd.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/fiehn-recruting-reel.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/kod-recruiting-vs.mp4",
          format: "9:16"
        }
      ],
      hero: {
        title: "Mitarbeiter begeistern, bevor sie sich bewerben",
        subtitle: "Recruiting-Videos sind Ihr Aushängeschild im War for Talents. Ich zeige echte Menschen, echte Geschichten und echte Perspektiven – so ziehen Sie die richtigen Talente an."
      },
      benefits: [
        "Authentische Mitarbeiter-Stories statt Hochglanz-Marketing",
        "Emotionale Ansprache Ihrer Zielgruppe",
        "Höhere Bewerberzahlen durch visuelle Kommunikation",
        "Optimiert für Social Media (TikTok, Instagram, LinkedIn)",
        "Stärkung Ihrer Arbeitgebermarke"
      ],
      process: [
        {
          title: "Zielgruppen-Analyse",
          description: "Welche Talente wollen Sie ansprechen? Gemeinsam definieren wir die perfekte Ansprache."
        },
        {
          title: "Storytelling & Interviews",
          description: "Ihre Mitarbeiter erzählen ihre Geschichte – authentisch und auf Augenhöhe."
        },
        {
          title: "Social-First Editing",
          description: "Kurze, knackige Videos, die im Feed stoppen und zum Bewerben motivieren."
        }
      ],
      useCases: [
        "Stellenanzeigen auf Social Media",
        "Karriere-Seiten auf der Website",
        "LinkedIn & XING Kampagnen",
        "Ausbildungs- & Trainee-Programme",
        "Messen & Recruiting-Events"
      ],
      cta: {
        title: "Recruiting neu gedacht?",
        subtitle: "Lassen Sie uns Ihre Arbeitgebermarke zum Leben erwecken."
      }
    },
    "social-media-content": {
      title: "Social Media Content",
      tagline: "Viral. Authentisch. Reichweitenstark.",
      description: "Social Media ist schnelllebig – und verlangt Content, der sofort fesselt. Von Instagram Reels über TikToks bis zu YouTube Shorts: Ich produziere vertikalen Content, der im Feed stoppt, Emotionen auslöst und maximale Reichweite erzielt.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/tag-3-gt3-rs-berge-2.mp4",
      heroVideoFormat: "9:16",
      additionalVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/urus-blau-dubai.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/cullinan-dubai-skyline.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-der-snack-der-dich-findet.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-salted.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/vs-weihnachtmaerkte-rueckblick-2024.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/stadt-villingen-abendflair.mp4",
          format: "9:16"
        }
      ],
      btsVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/img-1575.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/img-1800-2.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/sociale-media-vdieos-btsmp4.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/social-media-bts-3.mp4",
          format: "9:16"
        }
      ],
      hero: {
        title: "Content, der im Feed stoppt",
        subtitle: "Plattformgerecht, performanceorientiert und optimiert für Engagement. Schneller Content, der konvertiert."
      },
      benefits: [
        "Vertikale 9:16 Videos für Instagram, TikTok & YouTube Shorts",
        "Schnelle Turnaround-Zeiten für aktuelle Trends",
        "Hook-basiertes Storytelling für maximale Retention",
        "Optimiert auf Reichweite und Engagement",
        "Creator-Style für authentische Ansprache"
      ],
      process: [
        {
          title: "Trend-Recherche",
          description: "Welche Trends passen zu Ihrer Marke? Ich halte Sie immer up-to-date."
        },
        {
          title: "Content-Produktion",
          description: "Schnell, flexibel und plattformgerecht – für Content, der performt."
        },
        {
          title: "Iteratives Versioning",
          description: "A/B-Tests mit verschiedenen Hooks, Cuts und Formaten für maximale Performance."
        }
      ],
      useCases: [
        "Instagram Reels & TikToks",
        "YouTube Shorts",
        "LinkedIn Video-Content",
        "Facebook Video Ads",
        "Produkt-Launches & Kampagnen"
      ],
      cta: {
        title: "Bereit für viralen Content?",
        subtitle: "Lassen Sie uns gemeinsam Ihre Social-Media-Präsenz boosten."
      }
    },
    "hochzeitsvideo": {
      title: "Hochzeitsvideo",
      tagline: "Der schönste Tag. Für die Ewigkeit festgehalten.",
      description: "Eine Hochzeit ist einzigartig – und verdient ein Video, das die Emotionen, die Liebe und die besonderen Momente für immer bewahrt. Mit einem filmischen Blick für Details und Emotionen halte ich Ihren großen Tag fest – authentisch, berührend und zeitlos.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/hochzeit-von-sabrina-und-christian-15-10-22.mp4",
      additionalVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/hochzeitreel.mp4",
          format: "9:16"
        }
      ],
      hero: {
        title: "Emotionen, die bleiben",
        subtitle: "Von der Trauung bis zur Party: Ich fange die magischen Momente ein, die Ihr Herz höher schlagen lassen."
      },
      benefits: [
        "Cineastische Bildsprache mit emotionalem Storytelling",
        "Unauffällige Begleitung – ich bin da, ohne zu stören",
        "Highlight-Film + Vollversion für Ihre Erinnerungen",
        "Professionelles Color Grading und Sound Design",
        "Zeitloser Stil, der auch in 20 Jahren noch begeistert"
      ],
      process: [
        {
          title: "Kennenlernen",
          description: "Wir sprechen über Ihre Wünsche, den Ablauf und die besonderen Momente, die festgehalten werden sollen."
        },
        {
          title: "Der große Tag",
          description: "Ich begleite Sie diskret und professionell – von den Vorbereitungen bis zur Feier."
        },
        {
          title: "Ihr Hochzeitsfilm",
          description: "Innerhalb weniger Wochen erhalten Sie Ihren emotionalen Hochzeitsfilm – bereit zum Teilen und Wiedererleben."
        }
      ],
      useCases: [
        "Highlight-Film (3-5 Minuten)",
        "Vollversion (30-60 Minuten)",
        "Trauungs-Zeremonie",
        "Emotionale Momente (First Look, Reden, Tanz)",
        "Social Media Teaser für Instagram & Co."
      ],
      cta: {
        title: "Euer großer Tag verdient ein großartiges Video",
        subtitle: "Lasst uns gemeinsam unvergessliche Erinnerungen schaffen."
      }
    },
    "produktvideo": {
      title: "Produktvideo",
      tagline: "Produkte, die verkaufen. Visuell inszeniert.",
      description: "Ein gutes Produktvideo ist Verkaufsförderung pur. Ob für E-Commerce, Social Media oder Werbekampagnen – ich setze Ihre Produkte perfekt in Szene und schaffe Videos, die überzeugen und konvertieren.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/327-spirti-21-03-25.mp4",
      additionalVideos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-der-snack-der-dich-findet.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/rieggers-selection-15-03-25.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/sinn-uhr-2-25-04-25.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/tipp-kick-final-169.mp4"
      ],
      btsVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/327-spirti-21-03-25-2.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/produktvideo-bts-1.mp4",
          format: "9:16"
        },
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/produktvieo-bts-2.mp4",
          format: "9:16"
        }
      ],
      hero: {
        title: "Produkte, die begeistern",
        subtitle: "Von der Detailaufnahme bis zur emotionalen Inszenierung – ich mache Ihre Produkte zum Star."
      },
      benefits: [
        "Verkaufsstarke Produktinszenierung für E-Commerce",
        "UGC-Style für authentische Ansprache",
        "3D-Animationen & Motion Graphics auf Wunsch",
        "Optimiert für Website, Social Media & Ads",
        "Schnelle Turnaround-Zeiten für Produkt-Launches"
      ],
      process: [
        {
          title: "Produkt-Analyse",
          description: "Was macht Ihr Produkt besonders? Gemeinsam entwickeln wir die perfekte Inszenierung."
        },
        {
          title: "Shooting & Styling",
          description: "Professionelles Licht-Setup, Produktfotografie und Bewegtbild – alles aus einer Hand."
        },
        {
          title: "Postproduktion",
          description: "Color Grading, Motion Graphics und Sound Design für maximale Verkaufswirkung."
        }
      ],
      useCases: [
        "E-Commerce Product Videos (Amazon, Shopify, etc.)",
        "Social Media Ads (Instagram, Facebook, TikTok)",
        "Produktvorstellungen auf der Website",
        "Crowdfunding-Kampagnen",
        "Messe- & Event-Content"
      ],
      gallery: [
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-waffelburger.webp",          alt: "Waffelburger Produktshot",          caption: "Waffelburger · Studio" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-croissant-eis.webp",         alt: "Croissant mit Eis und Früchten",    caption: "Croissant · Eis · Früchte" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-erdbeer-nutella-waffel.webp", alt: "Erdbeer-Nutella-Waffel",          caption: "Erdbeer · Nutella · Waffel" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-donut-eis.webp",             alt: "Donut mit Eis",                     caption: "Donut · Eiskugel" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-dubai-chocolate.webp",       alt: "Dubai Chocolate Produktshot",       caption: "Dubai Chocolate" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-dsc09535.webp",              alt: "Produktshot — Studio Setup",        caption: "Studio · Tabletop" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-dsc09561.webp",              alt: "Produktshot — Detail",              caption: "Detail · Macro" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/produkt-dsc09580.webp",              alt: "Produktshot — Tabletop",            caption: "Tabletop · Lifestyle" },
      ],
      cta: {
        title: "Bereit, Ihre Produkte perfekt zu inszenieren?",
        subtitle: "Lassen Sie uns gemeinsam Videos schaffen, die verkaufen."
      }
    },
    "event-city": {
      title: "Event & City Marketing",
      tagline: "Events erleben. Städte entdecken. Atmosphäre spüren.",
      description: "Events und Stadtmarketing brauchen Videos, die Atmosphäre schaffen und Menschen begeistern. Ob Weihnachtsmarkt, Stadtfest oder Messe – ich fange die Stimmung ein und mache Lust auf mehr.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/stadt-villingen-abendflair.mp4",
      additionalVideos: [
        {
          url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/vs-weihnachtmaerkte-rueckblick-2024.mp4",
          format: "9:16"
        }
      ],
      btsPhotos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/rqfs5vic-20230709-dsc3139.jpg",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/3pjw0rc6-20230709-dsc3051.jpg",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/7bri57t1-20230709-dsc3200.jpg",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/hx9n1lnq-20230709-dsc3137.jpg"
      ],
      hero: {
        title: "Atmosphäre, die begeistert",
        subtitle: "Von Stadt-Kampagnen über Event-Coverage bis zu Messe-Videos – ich bringe die Energie Ihrer Events auf den Bildschirm."
      },
      benefits: [
        "Atmosphärische Aufnahmen mit Drohne & Gimbal",
        "Event-Coverage in Echtzeit für Social Media",
        "Stadt-Imagefilme für Tourismus & Marketing",
        "Recap-Videos & Highlight-Reels",
        "Optimiert für hohe Reichweite und Engagement"
      ],
      process: [
        {
          title: "Event-Planung",
          description: "Gemeinsam definieren wir die wichtigsten Momente und den visuellen Stil."
        },
        {
          title: "Live-Coverage",
          description: "Ich bin vor Ort und fange die Atmosphäre, Menschen und Highlights ein."
        },
        {
          title: "Schnelle Auslieferung",
          description: "Recap-Videos innerhalb von 48 Stunden – perfekt für Social Media und Nachberichterstattung."
        }
      ],
      useCases: [
        "Stadt-Imagefilme für Tourismus",
        "Weihnachtsmärkte & Stadtfeste",
        "Messen & Kongresse",
        "Konzerte & Kulturveranstaltungen",
        "Sportevents & Wettkämpfe"
      ],
      cta: {
        title: "Bereit, Ihr Event unvergesslich zu machen?",
        subtitle: "Lassen Sie uns gemeinsam Atmosphäre schaffen."
      }
    },
    "ki-video-generation": {
      title: "KI Video Generation",
      tagline: "Die Zukunft der Content-Erstellung. Schneller. Günstiger. Grenzenlos.",
      description: "Mit künstlicher Intelligenz erstellen wir Videos, die früher unmöglich oder unbezahlbar waren. Sprechende AI-Charaktere, automatisierte Produktvideos, KI-generierte Werbung – alles innerhalb von Stunden statt Wochen.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-begruessung.mp4",
      heroVideoFormat: "9:16",
      additionalVideos: [
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-werbung-seedos-black-week.mp4", format: "9:16" },
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-monitoris-steuer-a.mp4",      format: "9:16" },
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-monitoris-steuer-b.mp4",      format: "9:16" },
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-monitoris-trainer.mp4",       format: "9:16" },
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-seedos-spot.mp4",            format: "9:16" },
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-gold8-powder.mp4",            format: "9:16" },
        { url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/ki-koebi-testimonial.mp4",       format: "9:16" }
      ],
      hero: {
        title: "KI-Videos, die begeistern",
        subtitle: "Von sprechenden AI-Charakteren bis zu automatisierten Produktvideos – ich nutze modernste KI-Tools für deine Content-Strategie."
      },
      benefits: [
        "Sprechende AI-Charaktere in 50+ Sprachen",
        "Produktvideos automatisiert mit KI generieren",
        "AI-Werbeclips für Social Media in Minuten",
        "Kosteneffizienter als traditionelle Produktion",
        "Skalierbar: 10 oder 100 Videos zum gleichen Preis",
        "Freycreate.ai Integration für maximale Effizienz"
      ],
      process: [
        {
          title: "Beratung & Konzept",
          description: "Welche KI-Lösung passt zu deinem Projekt? Gemeinsam finden wir die beste Strategie."
        },
        {
          title: "KI-Produktion",
          description: "Mit Freycreate.ai erstellen wir deine Videos schnell und professionell — alles aus einer Plattform, die ich selbst entwickelt habe."
        },
        {
          title: "Workshop & Schulung",
          description: "Optional: Ich zeige dir, wie du selbst KI-Videos erstellst und dein Team schule ich im AI-Content-Workflow."
        }
      ],
      useCases: [
        "Sprechende AI-Avatare für Unternehmenskommunikation",
        "Produktvideos automatisiert generieren (E-Commerce)",
        "Mehrsprachige Videos ohne Synchronsprecher",
        "Social Media Content in Serie (10+ Videos/Tag)",
        "AI-Werbeclips für Meta/TikTok Ads",
        "Schulungsvideos & E-Learning mit AI",
        "KI Content Workshops für Teams"
      ],
      cta: {
        title: "Bereit für KI-Video-Produktion?",
        subtitle: "Buche jetzt ein kostenloses Beratungsgespräch oder einen Workshop."
      }
    },
    "immobilien": {
      title: "Immobilien & Architektur",
      tagline: "Räume erzählen Geschichten. Ich erzähle sie cineastisch.",
      description: "Hochwertige Immobilien- und Architekturvideos: Roomtours, Drohnenflüge, Lifestyle-Cuts. Maßgeschneidert für Makler, Bauträger und Eigentümer, die ihre Objekte nicht nur zeigen, sondern verkaufen wollen.",
      heroVideo: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/roomtour-penthouse-sigmaringen.mp4",
      additionalVideos: [],
      btsVideos: [],
      gallery: [
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/penthouse-dji_0999.webp", alt: "Penthouse Außenansicht — Drohne", caption: "Drohnen-Aufnahme · DJI" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/penthouse-dsc09548-hdr.webp", alt: "Penthouse Innenansicht HDR", caption: "Wohnbereich · HDR" },
        { src: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/penthouse-dsc09556-hdr.webp", alt: "Penthouse Detail HDR", caption: "Detail · HDR" },
      ],
      hero: {
        title: "Immobilien-Videos die verkaufen",
        subtitle: "Ein Video sagt mehr als 30 Bilder. Ich liefere Roomtours, Drohnenaufnahmen und stimmungsvolle Cuts, die Käufer emotional abholen — vom Penthouse bis zum Neubaugebiet."
      },
      benefits: [
        "Cineastische Roomtours mit Gimbal & FX-Slider",
        "Drohnenaufnahmen für Lage & Außenansicht",
        "Schnelle Lieferung – auch bei kurzfristigen Vermarktungsterminen",
        "Optimiert für YouTube, Instagram, Maklerplattformen",
        "Optional mit individuellem Sound-Design / Musiklizenz"
      ],
      process: [
        {
          title: "Briefing & Location-Check",
          description: "Wir besprechen Zielgruppe, USPs des Objekts und Drehkonzept. Bei Bedarf vorab Location-Scouting."
        },
        {
          title: "Drehtag",
          description: "Solo-Producer-Workflow: Boden-Aufnahmen mit Gimbal, dann Drohne. Ein Tag reicht meist für ein Standard-Objekt."
        },
        {
          title: "Postproduktion",
          description: "Schnitt, Color Grading, Sound-Design. Lieferung als 16:9 (YouTube/Web) plus optional 9:16 für Reels."
        },
        {
          title: "Lieferung",
          description: "Mehrere Versionen: lange Roomtour, kurzer Teaser, Reels-Cut. Innerhalb von 5–7 Werktagen."
        }
      ],
      formats: [
        "Roomtour (3–5 Min)",
        "Teaser (60 Sek)",
        "Reels / Shorts (15–30 Sek)",
        "Drohnen-Lage-Video"
      ],
      cta: {
        title: "Objekt zu vermarkten?",
        subtitle: "Hol dir ein unverbindliches Angebot — typischerweise innerhalb von 24 Stunden."
      }
    }
  };

  const serviceData = servicesData[slug];

  if (!serviceData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Service nicht gefunden</h2>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-[hsl(var(--accent))] text-white rounded-xl hover:bg-[hsl(var(--accent))]/90"
          >
            Zurück zur Startseite
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid="service-page">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden bg-secondary/30">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
          {/* Back button */}
          <button
            onClick={() => navigate('/')}
            className="mb-8 px-4 py-2 bg-secondary hover:bg-secondary/80 text-white rounded-xl flex items-center gap-2 transition-all"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück
          </button>

          {/* Hero Content */}
          <div className="text-center mb-12">
            <h1 className="text-5xl sm:text-6xl font-bold mb-4 gradient-text" data-testid="service-title">
              {serviceData.title}
            </h1>
            <p className="text-2xl text-muted-foreground mb-6">
              {serviceData.tagline}
            </p>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              {serviceData.description}
            </p>
          </div>

          {/* Video Placeholder or Real Video */}
          <div className={`${serviceData.heroVideoFormat === '9:16' ? 'aspect-[9/16] max-w-lg mx-auto' : 'aspect-video'} bg-secondary/50 rounded-2xl overflow-hidden hover-tilt border border-white/5`}>
            {serviceData.heroVideo ? (
              <video controls preload="metadata" className="w-full h-full object-cover">
                <source src={seekUrl(serviceData.heroVideo)} type="video/mp4" />
              </video>
            ) : (
              <div className="flex items-center justify-center h-full">
                <div className="text-center">
                  <Camera className="w-16 h-16 mx-auto mb-4 text-[hsl(var(--accent))]" />
                  <p className="text-muted-foreground">Video Platzhalter</p>
                  <p className="text-sm text-muted-foreground">Hier werden später Beispiel-Videos eingefügt</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
          {/* Why This Service */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-6">{serviceData.hero.title}</h2>
            <p className="text-xl text-muted-foreground leading-relaxed mb-8">
              {serviceData.hero.subtitle}
            </p>

            {/* Benefits */}
            <div className="grid md:grid-cols-2 gap-4">
              {(serviceData.benefits || []).map((benefit, index) => (
                <div key={index} className="flex items-start gap-3 bg-secondary/30 rounded-xl p-4">
                  <CheckCircle className="w-5 h-5 text-[hsl(var(--accent))] flex-shrink-0 mt-0.5" />
                  <span className="text-muted-foreground">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Additional Videos (if available) */}
          {serviceData.additionalVideos && serviceData.additionalVideos.length > 0 && (
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8">Weitere Beispiele</h2>
              <div className="grid md:grid-cols-3 gap-6">
                {(serviceData.additionalVideos || []).map((video, index) => {
                  const videoUrl = typeof video === 'string' ? video : video.url;
                  const videoFormat = typeof video === 'object' && video.format === '9:16' ? 'aspect-[9/16]' : 'aspect-video';
                  
                  return (
                    <div key={index} className={`${videoFormat} bg-secondary/50 rounded-xl overflow-hidden border border-white/5 mx-auto max-w-sm`}>
                      <video controls preload="metadata" className="w-full h-full object-cover">
                        <source src={seekUrl(videoUrl)} type="video/mp4" />
                      </video>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Image Gallery (if available) */}
          {serviceData.gallery && serviceData.gallery.length > 0 && (
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8">Bildergalerie</h2>
              {/* Masonry: jedes Bild in seinem natürlichen Format, dicht gepackt */}
              <div className="columns-2 md:columns-3 gap-3 md:gap-4">
                {(serviceData.gallery || []).map((img, index) => (
                  <a
                    key={index}
                    href={img.src || img}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative block mb-3 md:mb-4 break-inside-avoid overflow-hidden rounded-xl border border-white/5 bg-secondary/50"
                  >
                    <img
                      src={img.src || img}
                      alt={img.alt || "Produkt-Aufnahme"}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
                    />
                    {img.caption && (
                      <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity">
                        {img.caption}
                      </div>
                    )}
                  </a>
                ))}
              </div>
            </div>
          )}

          {/* Process */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8">So arbeite ich</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {(serviceData.process || []).map((step, index) => (
                <div key={index} className="bg-secondary/30 rounded-2xl p-6">
                  <div className="w-12 h-12 rounded-full bg-[hsl(var(--accent))]/20 flex items-center justify-center mb-4">
                    <span className="text-2xl font-bold text-[hsl(var(--accent))]">{index + 1}</span>
                  </div>
                  <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Use Cases */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-6">Einsatzbereiche</h2>
            <div className="bg-secondary/30 rounded-2xl p-8">
              <ul className="grid md:grid-cols-2 gap-4">
                {(serviceData.useCases || []).map((useCase, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Sparkles className="w-5 h-5 text-[hsl(var(--accent))] flex-shrink-0 mt-0.5" />
                    <span className="text-muted-foreground">{useCase}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* BTS Section */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-6">Behind the Scenes</h2>
            <p className="text-muted-foreground mb-8">
              Einblicke in die Produktion
            </p>
            
            {/* Multiple BTS Videos */}
            {serviceData.btsVideos && serviceData.btsVideos.length > 0 ? (
              <div className={`grid gap-6 mb-6 ${serviceData.btsVideos.length === 4 ? 'md:grid-cols-4' : 'md:grid-cols-3'}`}>
                {serviceData.btsVideos.map((btsVideo, index) => {
                  const videoFormat = btsVideo.format === '9:16' ? 'aspect-[9/16]' : 'aspect-video';
                  const containerClass = btsVideo.format === '9:16' ? 'mx-auto max-w-sm' : '';
                  
                  return (
                    <div key={index} className={`${videoFormat} ${containerClass} bg-secondary/50 rounded-2xl overflow-hidden border border-white/5`}>
                      <video controls preload="metadata" className="w-full h-full object-cover">
                        <source src={seekUrl(btsVideo.url)} type="video/mp4" />
                      </video>
                    </div>
                  );
                })}
              </div>
            ) : serviceData.btsVideo ? (
              <div className="grid md:grid-cols-2 gap-6">
                {/* Single BTS Video (backward compatibility) */}
                <div className="aspect-[9/16] md:aspect-video bg-secondary/50 rounded-2xl overflow-hidden border border-white/5">
                  <video controls preload="metadata" className="w-full h-full object-cover">
                    <source src={seekUrl(serviceData.btsVideo)} type="video/mp4" />
                  </video>
                </div>
                
                {/* BTS Photos Grid */}
                <div className="grid grid-cols-2 gap-4">
                  {serviceData.btsPhotos && serviceData.btsPhotos.length > 0 ? (
                    serviceData.btsPhotos.map((photo, index) => (
                      <div key={index} className="aspect-[3/2] bg-secondary/50 rounded-xl overflow-hidden border border-white/5">
                        <img src={photo} alt={`BTS Foto ${index + 1}`} className="w-full h-full object-cover" />
                      </div>
                    ))
                  ) : (
                    [1, 2, 3, 4].map((num) => (
                      <div key={num} className="aspect-[3/2] bg-secondary/50 rounded-xl overflow-hidden flex items-center justify-center border border-white/5">
                        <div className="text-center">
                          <Camera className="w-8 h-8 mx-auto mb-2 text-[hsl(var(--accent))]/50" />
                          <p className="text-xs text-muted-foreground">Foto {num}</p>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 gap-6">
                {/* BTS Video Placeholder */}
                <div className="aspect-video bg-secondary/50 rounded-2xl overflow-hidden border border-white/5">
                  <div className="flex items-center justify-center h-full">
                    <div className="text-center">
                      <Camera className="w-12 h-12 mx-auto mb-3 text-[hsl(var(--accent))]" />
                      <p className="text-muted-foreground text-sm">BTS Video Platzhalter</p>
                    </div>
                  </div>
                </div>
                
                {/* BTS Photos Grid */}
                <div className="grid grid-cols-2 gap-4">
                  {serviceData.btsPhotos && serviceData.btsPhotos.length > 0 ? (
                    serviceData.btsPhotos.map((photo, index) => (
                      <div key={index} className="aspect-[3/2] bg-secondary/50 rounded-xl overflow-hidden border border-white/5">
                        <img src={photo} alt={`BTS Foto ${index + 1}`} className="w-full h-full object-cover" />
                      </div>
                    ))
                  ) : (
                    [1, 2, 3, 4].map((num) => (
                      <div key={num} className="aspect-[3/2] bg-secondary/50 rounded-xl overflow-hidden flex items-center justify-center border border-white/5">
                        <div className="text-center">
                          <Camera className="w-8 h-8 mx-auto mb-2 text-[hsl(var(--accent))]/50" />
                          <p className="text-xs text-muted-foreground">Foto {num}</p>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-br from-[hsl(var(--accent))]/20 to-[hsl(var(--accent))]/5 rounded-2xl p-12 text-center">
            <h2 className="text-3xl font-bold mb-4">{serviceData.cta.title}</h2>
            <p className="text-xl text-muted-foreground mb-8">{serviceData.cta.subtitle}</p>
            <button
              onClick={() => navigate('/#contact')}
              className="px-8 py-4 bg-[hsl(var(--accent))] text-white rounded-xl hover:bg-[hsl(var(--accent))]/90 transition-all font-semibold"
            >
              Projekt anfragen
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicePage;
